

















import { Vue, Component } from 'vue-property-decorator'

import CenteredColumnLayout from '../../../../../components/CenteredColumnLayout.vue'
import BusinessRegistrationEmailValidationIcon
  from './components/BusinessRegistrationEmailValidationIcon.vue'
import BusinessRegistrationIDocumentIcon
  from './components/BusinessRegistrationIDocumentIcon.vue'
import BusinessRegistrationIntroIcon from './components/BusinessRegistrationIntroIcon.vue'
import BusinessRegistrationValidationRequestIcon
  from './components/BusinessRegistrationValidationRequestIcon.vue'
import CodeEmail from "./steps/CodeEmail.vue";
import CompanyDataTin from "./steps/CompanyDataTin.vue";
import EmailValidation from './steps/EmailValidation.vue'
import FinishRegistration from './steps/FinishRegistration.vue'
import Greeting from './steps/Greeting.vue'
import { CompanyData, CompanyRegistrationStep } from './types'

@Component({
  components: {
    CenteredColumnLayout,
    BusinessRegistrationIntroIcon,
    BusinessRegistrationIDocumentIcon,
    BusinessRegistrationEmailValidationIcon,
    BusinessRegistrationValidationRequestIcon,
  },
})
export default class Company extends Vue {
  currentStep: CompanyRegistrationStep = CompanyRegistrationStep.Greeting

  steps: { [key in CompanyRegistrationStep]: { view: typeof Vue } } = {
    [CompanyRegistrationStep.Greeting]: {
      view: Greeting,
    },
    [CompanyRegistrationStep.CompanyDataTin]: {
      view: CompanyDataTin,
    },
    [CompanyRegistrationStep.EmailValidation]: {
      view: EmailValidation,
    },
    [CompanyRegistrationStep.CodeEmail]: {
      view: CodeEmail,
    },
    [CompanyRegistrationStep.FinishRegistration]: {
      view: FinishRegistration,
    },
  }

  companyData: CompanyData = {
    // company: {
    inn: '',
    email: '',
    code: '',
    name: ''
    // },
    // company: {
    //   organization_name: '',
    //   person_name: '',
    //   person_type: '',
    //   base_type: '',
    //   organization_inn: '',
    //   organization_kpp: '',
    //   organization_ogrn: '',
    //   organization_account: '',
    //   organization_bank_account: '',
    //   organization_bank: '',
    //   organization_bik: '',
    //   organization_address_index: '',
    //   organization_address: '',
    //   organization_mail_address_index: '',
    //   organization_mail_address: '',
    //   organization_phone: '',
    //   email: '',
    //   email_confirmation_code: '',
    // },
    // document: null,
    // agreements: {
    //   valid_age: false,
    //   offer_check: false,
    //   privacy_agreement: false,
    // },
  }

  goToNextStep({ step }: { step: CompanyRegistrationStep }): void {
    this.currentStep = step
  }

  mounted() {
    // this.$store.dispatch('AdminTemplate/hideSaveConfigButton')
  }
}
